   export const ADD_TO_CART_REQUEST="ADD_TO_CART_REQUEST"
   export const ADD_TO_CART_SUCCESS="ADD_TO_CART_SUCCESS"
   export const ADD_TO_CART_FAILURE= "ADD_TO_CART_FAILURE"
   export const GET_FROM_CART_REQUEST="GET_FROM_CART_REQUEST"
   export const GET_FROM_CART_SUCCESS="GET_FROM_CART_SUCCESS"
   export const GET_FROM_CART_FAILURE="GET_FROM_CART_FAILURE"
   export const DELETE_FROM_CART_REQUEST="DELETE_FROM_CART_REQUEST"
   export const DELETE_FROM_CART_SUCCESS="DELETE_FROM_CART_SUCCESS"
   export const DELETE_FROM_CART_FAILURE="DELETE_FROM_CART_FAILURE"